export const REGIONS = {
    NA: "NA",
    EU: "EU",
    FE: "FE",
    IN: "IN"
}

export const STAGE = {
    BETA: "beta",
    GAMMA: "gamma",
    PROD: "prod"
}


export const ACCESS_TOKEN_NOT_FOUND_EXCEPTION = 'ACCESS_TOKEN_NOT_FOUND_EXCEPTION';
export const REFRESH_TOKEN_NOT_FOUND_EXCEPTION = 'REFRESH_TOKEN_NOT_FOUND_EXCEPTION';
// Key for refresh token in local storage
export const REFRESH_TOKEN_LOCALSTORAGE_ID = "refresh_token";
// Default time for token expiry 1 hour for Panda service
export const DEFAULT_TOKEN_EXPIRATION_TIME = 3600 * 1000;
// Refresh token if less than 15 minutes remaining or already expired
export const REFRESH_BEFORE_TIME = 15 * 60 * 1000;



// WEBPACK FOOTER //
// ./src/network/base/constants.js